<template>
  <nav class="sidebar col-md-3 col-lg-2 d-none d-md-block bg-light p-0">
    <div class="sidebar-sticky">
      <slot />
    </div>
  </nav>
</template>

<script>
export default {

};
</script>
<style scoped>
.sidebar {
  font-size: .875rem;
  z-index: 100; /* Behind the navbar */
}

.sidebar-sticky {
  position: relative;
  top: 48px;
  height: calc(100vh - 56px);
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}
</style>
